export const PROCESSOR_NAME = 'beatmate-engine';
